import { newQueryKeys } from '@/queries/queryKeys';
import { CreateReportEntity, ReportEntity } from '@/types';
import { QueryFunctionContext } from '@tanstack/react-query';
import APIService from './axios.service';
import { BaseService } from './base.service';
import { CustomResponse } from './type';

class ReportServiceClass extends BaseService<
  'report',
  ReportEntity,
  CreateReportEntity
> {
  constructor() {
    super('kits/reports');
  }

  getSequencing16sReport = (
    context: QueryFunctionContext<
      ReturnType<(typeof newQueryKeys)['report']['list']>
    >,
  ): Promise<CustomResponse<ReportEntity[]>> => {
    const { params } = context.queryKey[0];
    return APIService.get(this.path + '/sequencing-16s', { params });
  };

  getAnalysisReport = (
    context: QueryFunctionContext<
      ReturnType<(typeof newQueryKeys)['analysisReport']['list']>
    >,
  ): Promise<CustomResponse<ReportEntity[]>> => {
    const { params } = context.queryKey[0];
    return APIService.get(this.path + '/analysis-16s', { params });
  };
}

export const reportService = new ReportServiceClass();
